module.exports = __webpack_public_path__ + "static/img/ic-auth-succes.0c6bb53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-auth-succes.png
// module id = n+ov
// module chunks = 1